module.exports = __webpack_public_path__ + "static/media/silver_medal.60ad11ce.png";